import React, { Component } from "react";
import { Provider } from "react-redux";
import { Router, browserHistory } from "react-router";
import { syncHistoryWithStore } from "react-router-redux";
import { IntlProvider } from "react-intl";
import configureStore from "./redux/configureStore";
import LoginRequired from "./layouts/LoginRequired";
import routes from "./routes";

const store = configureStore({});

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store);

const intlFormats = {
  date: {
    short: {
      day: "numeric",
      month: "long",
    },
  },
  time: {
    short: {
      hour: "2-digit",
      minute: "2-digit",
    },
  },
};

export default class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <IntlProvider locale="en-AU" formats={intlFormats}>
          <span>
            <LoginRequired>
              <Router history={history}>{routes}</Router>
            </LoginRequired>
          </span>
        </IntlProvider>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.web.js